import React, { useEffect, useState } from "react";
import {
  Avatar,
  Badge,
  Box,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import settinglogo from "../../../assets/Images/SideMenueIcons/Setting-Normal.png";
import notificationlogo from "../../../assets/Images/SideMenueIcons/Notification-Normal.png";
import { KeyboardArrowDown } from "@mui/icons-material";
import { clearProfileData, clearToken } from '../../../Redux/Reducers/GlobalVar'
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../Redux/Store";
import ChangePassword from "./changePass";
import LoggedUser from "./loggedUser";
import { apiCallFriendList } from "../../../Core/Apicall";

function Header() {
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const data: any = useSelector((state: RootState) => state.global.token);
  const navigate = useNavigate()
  const dispatch = useDispatch();

  const [openChangePass, setOpenChangePass] = useState(false);
  const rawTitle = location.pathname.split("/")[2] || "";

  const [tableData, setTableData] = useState<any>();


  // Step 1: Insert spaces before capital letters
  let formattedTitle = rawTitle.replace(/([a-z])([A-Z])/g, "$1 $2");

  // Step 2: Remove + - * / or any other unwanted symbols
  formattedTitle = formattedTitle.replace(/[+\-*/]/g, " ");

  // Step 3: Capitalize first letter (optional, makes it neat)
  formattedTitle = formattedTitle.charAt(0).toUpperCase() + formattedTitle.slice(1);


  const userName = data?.data?.fullName || "Admin";

  const handleApiCall = async () => {
    try {
      const datauser = { userId: data?.data?.userId };
      const res = await apiCallFriendList(datauser);
      setTableData(res?.data);
    } catch (err) { }
  };

  useEffect(() => {
    handleApiCall()
  }, []);

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(clearToken());
    dispatch(clearProfileData());


    navigate(`/admin/login`)
  }

  const handleChangePassword = () => {
    handleClose(); // close dropdown first
    setOpenChangePass(true);
  }

  return (
    <Box
      bgcolor="#ffffff"
      className="w-100 sidemenue px-3 d-flex align-items-center justify-content-between"
      zIndex="2"
      height="64px"
    >
      <Typography variant="h5">{formattedTitle}</Typography>

      <Box className="d-flex align-items-center gap-3">
        <IconButton>
          <Badge badgeContent={2} className="badge p-0 pt-1">
            <img height="24px" src={settinglogo} alt="" />
          </Badge>
        </IconButton>

        <IconButton>
          <Badge badgeContent={2} className="badge p-0 pt-1">
            <img height="24px" className="p-0" src={notificationlogo} alt="" />
          </Badge>
        </IconButton>

        <Box className="user d-flex gap-2 me-2 align-items-center">
          <Avatar
            src={tableData?.profileImagePath || userName.charAt(0).toUpperCase()}
            className="text-center" sx={{ bgcolor: "black" }}>
            {userName.charAt(0).toUpperCase()}
          </Avatar>
          <Box>
            <Typography>{userName}</Typography>
          </Box>
          <IconButton onClick={handleMenuClick}>
            <KeyboardArrowDown />
          </IconButton>
        </Box>

        {/* Dropdown Menu */}
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
          <MenuItem onClick={handleChangePassword}>Change Password</MenuItem>
        </Menu>

        {/* <LoggedUser /> */}

      </Box>

      {/* Dialog with ChangePassword form */}
      <Dialog
      
        // className="changepass"
        open={openChangePass}
        onClose={() => setOpenChangePass(false)}
        // maxWidth="sm"
        // fullWidth
      >
        <DialogContent style={{}}>
          {/* pass onClose to child */}
          <ChangePassword onClose={() => setOpenChangePass(false)} />
        </DialogContent>
      </Dialog>

    </Box>
  );
}

export default Header;
